import { db } from "./firebase";
import {
  ref,
  get,
  query,
  orderByChild,
  update,
  remove,
} from "firebase/database";

export const getSupportInquiriesList = async () => {
  try {
    const supportRef = ref(db, "contacthq/contact-support"); // Path based on your submission logic
    const snapshot = await get(query(supportRef, orderByChild("createdAt")));

    if (!snapshot.exists()) return { success: true, data: [] };

    const data = Object.entries(snapshot.val()).map(([id, val]) => ({
      id,
      ...val,
    }));

    return { success: true, data: data.reverse() }; // Newest first
  } catch (error) {
    console.error("🔥 Fetch Support Error:", error);
    return { success: false, message: error.message };
  }
};

export const getBugReportsList = async () => {
  try {
    const bugRef = ref(db, "contacthq/bug-reports");
    const snapshot = await get(query(bugRef, orderByChild("createdAt")));

    if (!snapshot.exists()) return { success: true, data: [] };

    const data = Object.entries(snapshot.val()).map(([id, val]) => ({
      id,
      ...val,
    }));

    return { success: true, data: data.reverse() };
  } catch (error) {
    console.error("🔥 Fetch Bug Error:", error);
    return { success: false, message: error.message };
  }
};

export const updateTicketStatus = async (type, id, updates) => {
  try {
    const path =
      type === "bug"
        ? `contacthq/bug-reports/${id}`
        : `contacthq/contact-support/${id}`;
    const ticketRef = ref(db, path);

    await update(ticketRef, {
      ...updates,
      updatedAt: new Date().toISOString(),
    });

    return { success: true, message: "Ticket successfully synchronized." };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const deleteTicketRecord = async (type, id) => {
  try {
    const path =
      type === "bug"
        ? `contacthq/bug-reports/${id}`
        : `contacthq/contact-support/${id}`;
    const ticketRef = ref(db, path);

    await remove(ticketRef);
    return { success: true, message: "Record removed from orchestrator." };
  } catch (error) {
    return { success: false, message: error.message };
  }
};






export const getServiceLeads = async () => {
  try {
    const supportRef = ref(db, 'contacthq/service-leads');
    const snapshot = await get(supportRef);
    
    if (snapshot.exists()) {
      const allData = Object.values(snapshot.val());
      // Filter for Project Leads and sort by newest first
      const serviceLeads = allData
        .filter(item => item.formCategory === "Project Lead")
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        
      return { success: true, data: serviceLeads };
    }
    return { success: true, data: [] };
  } catch (error) {
    console.error("Error fetching service leads:", error);
    return { success: false, error: error.message };
  }
};

// Update the status of a lead
export const updateLeadStatus = async (id, newStatus) => {
  try {
    const leadRef = ref(db, `contacthq/service-leads/${id}`);
    await update(leadRef, { status: newStatus });
    return { success: true };
  } catch (error) {
    console.error("Error updating lead status:", error);
    return { success: false, error: error.message };
  }
};

// Delete a lead
export const deleteServiceLead = async (id) => {
  try {
    const leadRef = ref(db, `contacthq/service-leads/${id}`);
    await remove(leadRef);
    return { success: true };
  } catch (error) {
    console.error("Error deleting lead:", error);
    return { success: false, error: error.message };
  }
};